export interface FormatOptions {
  locale?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
}

export function formatNumber(
  value: number,
  options: FormatOptions = {}
): string {
  if (isNaN(value) || value === null || value === undefined) {
      return '';
  }

  const isInteger = Number.isInteger(value);
  const locale =  'pt-BR';
  const minimumFractionDigits = options.minimumFractionDigits ?? (isInteger ? 0 : 2);
  const maximumFractionDigits = options.maximumFractionDigits ?? 2;

  return new Intl.NumberFormat(locale, {
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(value);
}
